import './DocInfo.svelte.css';
/* src/DocInfo.svelte generated by Svelte v3.43.1 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_block,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text,
	toggle_class,
	update_keyed_each
} from "../_snowpack/pkg/svelte/internal.js";

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[13] = list[i];
	return child_ctx;
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

// (101:37) 
function create_if_block_5(ctx) {
	let pre;
	let t_value = JSON.stringify(/*doc*/ ctx[1].as_positional_patch(), null, 2) + "";
	let t;

	return {
		c() {
			pre = element("pre");
			t = text(t_value);
			attr(pre, "class", "svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, pre, anchor);
			append(pre, t);
		},
		p(ctx, dirty) {
			if (dirty & /*doc*/ 2 && t_value !== (t_value = JSON.stringify(/*doc*/ ctx[1].as_positional_patch(), null, 2) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(pre);
		}
	};
}

// (97:38) 
function create_if_block_4(ctx) {
	let pre;
	let t_value = JSON.stringify(/*doc*/ ctx[1].get_txn_since([]), null, 2) + "";
	let t;

	return {
		c() {
			pre = element("pre");
			t = text(t_value);
			attr(pre, "class", "svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, pre, anchor);
			append(pre, t);
		},
		p(ctx, dirty) {
			if (dirty & /*doc*/ 2 && t_value !== (t_value = JSON.stringify(/*doc*/ ctx[1].get_txn_since([]), null, 2) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(pre);
		}
	};
}

// (61:34) 
function create_if_block_1(ctx) {
	let t;
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let if_block = /*entries*/ ctx[2].length > 0 && create_if_block_3(ctx);
	let each_value_2 = /*entries*/ ctx[2];
	const get_key = ctx => /*entry*/ ctx[13].order;

	for (let i = 0; i < each_value_2.length; i += 1) {
		let child_ctx = get_each_context_2(ctx, each_value_2, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_2(key, child_ctx));
	}

	let each_1_else = null;

	if (!each_value_2.length) {
		each_1_else = create_else_block_2(ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			t = space();
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			if (each_1_else) {
				each_1_else.c();
			}

			attr(div, "class", "spaceEntries svelte-18nmlxg");
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			if (each_1_else) {
				each_1_else.m(div, null);
			}
		},
		p(ctx, dirty) {
			if (/*entries*/ ctx[2].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(t.parentNode, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*entries, bgOrderColor, fgOrderColor, JSON*/ 100) {
				each_value_2 = /*entries*/ ctx[2];
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_2, each_1_lookup, div, destroy_block, create_each_block_2, null, get_each_context_2);

				if (each_value_2.length) {
					if (each_1_else) {
						each_1_else.d(1);
						each_1_else = null;
					}
				} else if (!each_1_else) {
					each_1_else = create_else_block_2(ctx);
					each_1_else.c();
					each_1_else.m(div, null);
				}
			}
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			if (each_1_else) each_1_else.d();
		}
	};
}

// (36:4) {#if tabName === 'info'}
function create_if_block(ctx) {
	let ul;
	let li0;
	let span0;
	let t1;
	let span1;
	let t2_value = /*doc*/ ctx[1].get_next_order() + "";
	let t2;
	let t3;
	let li1;
	let span2;
	let t5;
	let div0;
	let t6;
	let li2;
	let span3;
	let t8;
	let div1;
	let each_value_1 = /*doc*/ ctx[1].get_vector_clock();
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each0_else = null;

	if (!each_value_1.length) {
		each0_else = create_else_block(ctx);
	}

	let each_value = /*doc*/ ctx[1].get_frontier();
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			ul = element("ul");
			li0 = element("li");
			span0 = element("span");
			span0.textContent = "Next order:";
			t1 = space();
			span1 = element("span");
			t2 = text(t2_value);
			t3 = space();
			li1 = element("li");
			span2 = element("span");
			span2.textContent = "Vector clock:";
			t5 = space();
			div0 = element("div");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			if (each0_else) {
				each0_else.c();
			}

			t6 = space();
			li2 = element("li");
			span3 = element("span");
			span3.textContent = "Frontier:";
			t8 = space();
			div1 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(span0, "class", "svelte-18nmlxg");
			attr(span1, "class", "svelte-18nmlxg");
			attr(li0, "class", "item svelte-18nmlxg");
			attr(span2, "class", "svelte-18nmlxg");
			attr(div0, "class", "clocks svelte-18nmlxg");
			attr(li1, "class", "item svelte-18nmlxg");
			attr(span3, "class", "svelte-18nmlxg");
			attr(div1, "class", "clocks svelte-18nmlxg");
			attr(li2, "class", "item svelte-18nmlxg");
			attr(ul, "class", "infoTab svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, span0);
			append(li0, t1);
			append(li0, span1);
			append(span1, t2);
			append(ul, t3);
			append(ul, li1);
			append(li1, span2);
			append(li1, t5);
			append(li1, div0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(div0, null);
			}

			if (each0_else) {
				each0_else.m(div0, null);
			}

			append(ul, t6);
			append(ul, li2);
			append(li2, span3);
			append(li2, t8);
			append(li2, div1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div1, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*doc*/ 2 && t2_value !== (t2_value = /*doc*/ ctx[1].get_next_order() + "")) set_data(t2, t2_value);

			if (dirty & /*JSON, doc*/ 2) {
				each_value_1 = /*doc*/ ctx[1].get_vector_clock();
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div0, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;

				if (each_value_1.length) {
					if (each0_else) {
						each0_else.d(1);
						each0_else = null;
					}
				} else if (!each0_else) {
					each0_else = create_else_block(ctx);
					each0_else.c();
					each0_else.m(div0, null);
				}
			}

			if (dirty & /*JSON, doc*/ 2) {
				each_value = /*doc*/ ctx[1].get_frontier();
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div1, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks_1, detaching);
			if (each0_else) each0_else.d();
			destroy_each(each_blocks, detaching);
		}
	};
}

// (62:6) {#if entries.length > 0}
function create_if_block_3(ctx) {
	let div;
	let label;
	let input;
	let t;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			label = element("label");
			input = element("input");
			t = text("\n            RLE items");
			attr(input, "type", "checkbox");
			attr(div, "class", "options svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(label, input);
			input.checked = /*rleItems*/ ctx[0];
			append(label, t);

			if (!mounted) {
				dispose = listen(input, "change", /*input_change_handler*/ ctx[7]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*rleItems*/ 1) {
				input.checked = /*rleItems*/ ctx[0];
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (92:8) {:else}
function create_else_block_2(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = "Type something in the box above!";
			set_style(div, "color", "white");
			set_style(div, "font-style", "italic");
			attr(div, "class", "svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (83:12) {:else}
function create_else_block_1(ctx) {
	let div;
	let t0;
	let span;
	let t1_value = JSON.stringify(/*entry*/ ctx[13].content) + "";
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text("Content: ");
			span = element("span");
			t1 = text(t1_value);
			set_style(span, "font-family", "monospace");
			attr(div, "class", "svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, span);
			append(span, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*entries*/ 4 && t1_value !== (t1_value = JSON.stringify(/*entry*/ ctx[13].content) + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (81:12) {#if entry.isDeleted}
function create_if_block_2(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = "DELETED";
			attr(div, "class", "svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (71:8) {#each entries as entry (entry.order)}
function create_each_block_2(key_1, ctx) {
	let div3;
	let div0;
	let t0;

	let t1_value = (/*entry*/ ctx[13].len > 1
	? `${/*entry*/ ctx[13].order} - ${/*entry*/ ctx[13].order + /*entry*/ ctx[13].len - 1}`
	: /*entry*/ ctx[13].order) + "";

	let t1;
	let t2;
	let div1;
	let t3;
	let span0;
	let t4_value = /*entry*/ ctx[13].originLeft + "";
	let t4;
	let t5;
	let t6;
	let div2;
	let t7;
	let span1;
	let t8_value = /*entry*/ ctx[13].originRight + "";
	let t8;
	let t9;

	function select_block_type_1(ctx, dirty) {
		if (/*entry*/ ctx[13].isDeleted) return create_if_block_2;
		return create_else_block_1;
	}

	let current_block_type = select_block_type_1(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		key: key_1,
		first: null,
		c() {
			div3 = element("div");
			div0 = element("div");
			t0 = text("Order: ");
			t1 = text(t1_value);
			t2 = space();
			div1 = element("div");
			t3 = text("Origin left: ");
			span0 = element("span");
			t4 = text(t4_value);
			t5 = space();
			if_block.c();
			t6 = space();
			div2 = element("div");
			t7 = text("Origin right: ");
			span1 = element("span");
			t8 = text(t8_value);
			t9 = space();
			attr(div0, "class", "svelte-18nmlxg");
			attr(span0, "class", "origin svelte-18nmlxg");
			set_style(span0, "background-color", /*bgOrderColor*/ ctx[5](/*entry*/ ctx[13].originLeft));
			set_style(span0, "color", /*fgOrderColor*/ ctx[6](/*entry*/ ctx[13].originLeft));
			attr(div1, "class", "svelte-18nmlxg");
			attr(span1, "class", "origin svelte-18nmlxg");
			set_style(span1, "background-color", /*bgOrderColor*/ ctx[5](/*entry*/ ctx[13].originRight));
			set_style(span1, "color", /*fgOrderColor*/ ctx[6](/*entry*/ ctx[13].originRight));
			attr(div2, "class", "svelte-18nmlxg");
			set_style(div3, "background", /*entry*/ ctx[13].color);
			attr(div3, "class", "svelte-18nmlxg");
			this.first = div3;
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			append(div3, div0);
			append(div0, t0);
			append(div0, t1);
			append(div3, t2);
			append(div3, div1);
			append(div1, t3);
			append(div1, span0);
			append(span0, t4);
			append(div3, t5);
			if_block.m(div3, null);
			append(div3, t6);
			append(div3, div2);
			append(div2, t7);
			append(div2, span1);
			append(span1, t8);
			append(div3, t9);
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*entries*/ 4 && t1_value !== (t1_value = (/*entry*/ ctx[13].len > 1
			? `${/*entry*/ ctx[13].order} - ${/*entry*/ ctx[13].order + /*entry*/ ctx[13].len - 1}`
			: /*entry*/ ctx[13].order) + "")) set_data(t1, t1_value);

			if (dirty & /*entries*/ 4 && t4_value !== (t4_value = /*entry*/ ctx[13].originLeft + "")) set_data(t4, t4_value);

			if (dirty & /*entries*/ 4) {
				set_style(span0, "background-color", /*bgOrderColor*/ ctx[5](/*entry*/ ctx[13].originLeft));
			}

			if (dirty & /*entries*/ 4) {
				set_style(span0, "color", /*fgOrderColor*/ ctx[6](/*entry*/ ctx[13].originLeft));
			}

			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div3, t6);
				}
			}

			if (dirty & /*entries*/ 4 && t8_value !== (t8_value = /*entry*/ ctx[13].originRight + "")) set_data(t8, t8_value);

			if (dirty & /*entries*/ 4) {
				set_style(span1, "background-color", /*bgOrderColor*/ ctx[5](/*entry*/ ctx[13].originRight));
			}

			if (dirty & /*entries*/ 4) {
				set_style(span1, "color", /*fgOrderColor*/ ctx[6](/*entry*/ ctx[13].originRight));
			}

			if (dirty & /*entries*/ 4) {
				set_style(div3, "background", /*entry*/ ctx[13].color);
			}
		},
		d(detaching) {
			if (detaching) detach(div3);
			if_block.d();
		}
	};
}

// (47:12) {:else}
function create_else_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.textContent = "(implicitly 0 everywhere)";
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (45:12) {#each doc.get_vector_clock() as clock}
function create_each_block_1(ctx) {
	let div;
	let t_value = JSON.stringify(/*clock*/ ctx[8]) + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*doc*/ 2 && t_value !== (t_value = JSON.stringify(/*clock*/ ctx[8]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (55:12) {#each doc.get_frontier() as clock}
function create_each_block(ctx) {
	let div;
	let t_value = JSON.stringify(/*clock*/ ctx[8]) + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*doc*/ 2 && t_value !== (t_value = JSON.stringify(/*clock*/ ctx[8]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let div2;
	let div0;
	let a0;
	let t1;
	let a1;
	let t3;
	let a2;
	let t5;
	let a3;
	let t7;
	let div1;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*tabName*/ ctx[3] === 'info') return create_if_block;
		if (/*tabName*/ ctx[3] === 'space') return create_if_block_1;
		if (/*tabName*/ ctx[3] === 'time-crdt') return create_if_block_4;
		if (/*tabName*/ ctx[3] === 'time-pos') return create_if_block_5;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type && current_block_type(ctx);

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			a0 = element("a");
			a0.textContent = "Info";
			t1 = space();
			a1 = element("a");
			a1.textContent = "Space";
			t3 = space();
			a2 = element("a");
			a2.textContent = "Time (CRDT)";
			t5 = space();
			a3 = element("a");
			a3.textContent = "Time (Pos)";
			t7 = space();
			div1 = element("div");
			if (if_block) if_block.c();
			attr(a0, "href", "/");
			attr(a0, "class", "svelte-18nmlxg");
			toggle_class(a0, "enabled", /*tabName*/ ctx[3] == 'info');
			attr(a1, "href", "/");
			attr(a1, "class", "svelte-18nmlxg");
			toggle_class(a1, "enabled", /*tabName*/ ctx[3] == 'space');
			attr(a2, "href", "/");
			attr(a2, "class", "svelte-18nmlxg");
			toggle_class(a2, "enabled", /*tabName*/ ctx[3] == 'time-crdt');
			attr(a3, "href", "/");
			attr(a3, "class", "svelte-18nmlxg");
			toggle_class(a3, "enabled", /*tabName*/ ctx[3] == 'time-pos');
			attr(div0, "class", "nav svelte-18nmlxg");
			attr(div1, "class", "content svelte-18nmlxg");
			attr(div2, "class", "component svelte-18nmlxg");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			append(div0, a0);
			append(div0, t1);
			append(div0, a1);
			append(div0, t3);
			append(div0, a2);
			append(div0, t5);
			append(div0, a3);
			append(div2, t7);
			append(div2, div1);
			if (if_block) if_block.m(div1, null);

			if (!mounted) {
				dispose = [
					listen(a0, "click", /*setTab*/ ctx[4]('info')),
					listen(a1, "click", /*setTab*/ ctx[4]('space')),
					listen(a2, "click", /*setTab*/ ctx[4]('time-crdt')),
					listen(a3, "click", /*setTab*/ ctx[4]('time-pos'))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*tabName*/ 8) {
				toggle_class(a0, "enabled", /*tabName*/ ctx[3] == 'info');
			}

			if (dirty & /*tabName*/ 8) {
				toggle_class(a1, "enabled", /*tabName*/ ctx[3] == 'space');
			}

			if (dirty & /*tabName*/ 8) {
				toggle_class(a2, "enabled", /*tabName*/ ctx[3] == 'time-crdt');
			}

			if (dirty & /*tabName*/ 8) {
				toggle_class(a3, "enabled", /*tabName*/ ctx[3] == 'time-pos');
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if (if_block) if_block.d(1);
				if_block = current_block_type && current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div1, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);

			if (if_block) {
				if_block.d();
			}

			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { doc } = $$props;
	let { entries } = $$props;
	let { rleItems = true } = $$props;

	// let tabName: TabName = 'time-crdt'
	// let tabName: TabName = 'info'
	let tabName = 'space';

	const setTab = name => e => {
		$$invalidate(3, tabName = name);
		e.preventDefault();
	};

	const bgOrderColor = order => {
		var _a, _b;

		return order === 'ROOT'
		? 'black'
		: (_b = (_a = entries.find(e => e.order <= order && order < e.order + e.len)) === null || _a === void 0
			? void 0
			: _a.color) !== null && _b !== void 0
			? _b
			: 'black';
	};

	const fgOrderColor = order => order === 'ROOT' ? 'white' : 'black';

	function input_change_handler() {
		rleItems = this.checked;
		$$invalidate(0, rleItems);
	}

	$$self.$$set = $$props => {
		if ('doc' in $$props) $$invalidate(1, doc = $$props.doc);
		if ('entries' in $$props) $$invalidate(2, entries = $$props.entries);
		if ('rleItems' in $$props) $$invalidate(0, rleItems = $$props.rleItems);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*rleItems*/ 1) {
			$: {
				console.log('rle info', rleItems);
			}
		}
	};

	return [
		rleItems,
		doc,
		entries,
		tabName,
		setTab,
		bgOrderColor,
		fgOrderColor,
		input_change_handler
	];
}

class DocInfo extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { doc: 1, entries: 2, rleItems: 0 });
	}
}

export default DocInfo;